<template>
  <div class="errPage-container">
    <div class="err-content">
      <div class="err-text">
        <h1 class="err-code">401</h1>
        <h2 class="err-title">Unauthorized</h2>
        <p class="err-info">
          Sorry, you don't have permission to access this page.
          Please contact your administrator if you believe this is a mistake.
        </p>
        <div class="err-actions">
          <el-button
            type="primary"
            @click="back"
          >
            Back to Home
          </el-button>
        </div>
      </div>
      <div class="err-img">
        <img
          :src="errGif"
          alt="Unauthorized"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs } from 'vue'
import errGif from '@/assets/401-images/401.gif'
import { useRoute, useRouter } from 'vue-router'

export default defineComponent({
  setup() {
    const route = useRoute()
    const router = useRouter()

    const data = reactive({
      errGif,
      back() {
        if (route.query.noGoBack) {
          router.push({ path: '/dashboard' }).catch(err => {
            console.warn(err)
          })
        } else {
          router.go(-1)
        }
      }
    })

    return { ...toRefs(data) }
  }
})
</script>

<style lang="scss" scoped>
.errPage-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 24px;

  .err-content {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 48px;
    max-width: 900px;
  }

  .err-text {
    flex: 1 1 320px;
    max-width: 420px;

    .err-code {
      font-size: 64px;
      font-weight: 700;
      line-height: 1;
      margin: 0;
      color: var(--el-color-primary, #409eff);
    }

    .err-title {
      font-size: 24px;
      font-weight: 600;
      margin: 12px 0;
      color: #303133;
    }

    .err-info {
      font-size: 14px;
      line-height: 1.6;
      color: #909399;
      margin-bottom: 24px;
    }
  }

  .err-img {
    flex: 0 1 320px;

    img {
      display: block;
      width: 100%;
      max-width: 360px;
      height: auto;
    }
  }
}
</style>
